import React, { useState, useEffect } from 'react';
import { MapRedirect } from '@innovyze/app-am-network/Pages';
import { LoadingPage } from '@innovyze/stylovyze';

export const MapRedirectWithDelay = () => {
	const [isDelaying, setIsDelaying] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			setIsDelaying(false);
		}, 300);
	}, []);

	return isDelaying ? <LoadingPage /> : <MapRedirect />;
};
